export default __webpack_public_path__ + "static/media/loading-indicator-default.3b21e5f3.gif";